// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tabla-programas .nombre-programa{
    border-bottom: 1px solid #007932;
    margin-right: 50px;
}

/* Servicios del ayuntamiento section */
.informacion-social:last-child .titulo-user {
    margin-top: 50px;
}

/* Styling for services cards */
.noticias-container .noticia.servicio-ayuntamiento {
    padding-bottom: 20px;
}

.noticias-container .noticia.servicio-ayuntamiento a {
    color: #002079;
}

.noticias-container .noticia.servicio-ayuntamiento a:hover {
    text-decoration: underline;
}`, "",{"version":3,"sources":["webpack://./src/pages/admin/css/Social.css"],"names":[],"mappings":"AAAA;IACI,gCAAgC;IAChC,kBAAkB;AACtB;;AAEA,uCAAuC;AACvC;IACI,gBAAgB;AACpB;;AAEA,+BAA+B;AAC/B;IACI,oBAAoB;AACxB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,0BAA0B;AAC9B","sourcesContent":[".tabla-programas .nombre-programa{\n    border-bottom: 1px solid #007932;\n    margin-right: 50px;\n}\n\n/* Servicios del ayuntamiento section */\n.informacion-social:last-child .titulo-user {\n    margin-top: 50px;\n}\n\n/* Styling for services cards */\n.noticias-container .noticia.servicio-ayuntamiento {\n    padding-bottom: 20px;\n}\n\n.noticias-container .noticia.servicio-ayuntamiento a {\n    color: #002079;\n}\n\n.noticias-container .noticia.servicio-ayuntamiento a:hover {\n    text-decoration: underline;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
